import * as React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 77px;
  padding: 10px 25px 40px;
  height: 100vh;
  overflow: hidden;
`;

const GreetingFrame = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 155px 0 20px;
  width: 100%;
  height: 100%;
  border: 1px solid #dfdfdf;
  background: url(${require('../../assets/greeting/flower_top@2x.png')}) center 30px no-repeat;
  background-size: 198px;

  &::before,
  :after  {
    content: "";
    position: absolute;
    top: -60px; left: -60px;
    width: 100px;
    height: 100px;
    border-bottom: 2px solid #e1b949;
    background: #fff;
    transform: rotate(-45deg);
  }

  &::after {
    top: auto; left: auto;
    bottom: -60px; right: -60px;
    transform: rotate(135deg);
  }

  & h2 {
    margin-bottom: 10px;
    font-size: 20px;
    font-weight: bold;
  }

  & p {
    padding: 0 10px;
    line-height: 25px;
    font-size: 14px;
    text-align: center;

    &:nth-child(4) {
      margin-top: 20px;
    }
  }
  @media (min-width: 500px) and (max-width: 850px) and (orientation: landscape) {
    flex-direction: row;
    padding: 20px 0;

    & > div {
      margin-top: 0;
    }

    & > div:first-child {
      margin-right: 10%;
    }

    & p {
      color: #000;
      text-shadow: 2px 2px 10px #fff;
    }
  }
`;

const TelWrap = styled.div`
  display: flex;
  margin-top: 40px;
`;

const Tel = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 35px;
  width: 85px;
  height: 80px;
  line-height: 18px;
  font-size: 14px;
  background: url(${require('../../assets/greeting/circle_blur_blue@2x.png')}) 0 0 no-repeat;
  background-size: 100%;

  &:last-child {
    margin: 0 0 0 40px;
    background-image: url(${require('../../assets/greeting/circle_blur_purple@2x.png')});
  }
`;

interface IProps {
  messages?: any;
  lang?: string;
}

const Greeting = ({messages, lang} : IProps) => {
  const invitePeople = window.location.pathname.split('/')[3];
  const inviteText = lang === 'ko-KR' ? `${decodeURI(invitePeople)}${messages.invite}` : `${messages.invite} ${decodeURI(invitePeople)}`

  return (
    <Wrap>
      <GreetingFrame>
        { invitePeople && <h2>{inviteText}</h2> }
        <div>
          {messages.greeting.map((greeting: string, index: number) => <p key={index}>{greeting}</p>)}
        </div>
        <TelWrap>
          {messages.telWho.map((telWho: string, index: number) => <Tel href={index === 0 ? 'tel:01071667742' : 'tel:01084374123'} key={index}>{telWho}</Tel>)}
        </TelWrap>
      </GreetingFrame>
    </Wrap>
  );
}

export default Greeting;


// WEBPACK FOOTER //
// ./src/components/greeting/index.tsx